import script from "./EventBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./EventBanner.vue?vue&type=script&setup=true&lang=js"

import "./EventBanner.vue?vue&type=style&index=0&id=3fe7bbdc&scoped=true&lang=css"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fe7bbdc"]])

export default __exports__